import OtherItem from "./OtherItem";
import {wraps,sandwiches,burgers,frenchfries,popcorns,biryani,mocktails,biryani,iceCreams} from '../services/ItemsApi'


const OtherItemsDisplay = ({type}) => {
    const getitems = (name) => {
        if(name==="Wraps"){
            return wraps();
        }
        if(name==="Grill Sandwich"){
            return sandwiches();
        }
        if(name==="Burgers"){
            return burgers();
        }
        if(name==="PopCorns"){
            return popcorns();
        }
        if(name==="French Fries"){
            return frenchfries();
        }
        if(name==="Biriyani"){
            return biryani();
        }
        if(name==="Mocktails"){
            return mocktails();
        }
        if(name === "Ice Creams"){
            return iceCreams();
        }
    } 
    
    
    const itemslist = getitems(type);

    return itemslist.map((item,index)=><OtherItem key={item.name} name={item.name} price={item.price}/>);
}
 
export default OtherItemsDisplay;